import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgJusbrasilConnections(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M81.866 82.86c0 11.838-9.596 21.434-21.433 21.434S39 94.698 39 82.861s9.596-21.433 21.433-21.433 21.433 9.596 21.433 21.433Z"
        fill="#E6F4F0"
      />
      <path
        d="M71.339 100.38a.8.8 0 1 1 .847 1.358 22.138 22.138 0 0 1-11.753 3.356c-3.477 0-6.77-.799-9.703-2.223a.801.801 0 0 1 .699-1.44 20.552 20.552 0 0 0 9.004 2.063c4.005 0 7.742-1.14 10.906-3.114ZM38.2 82.86c0-8.23 4.472-15.414 11.115-19.257a.8.8 0 0 1 .802 1.385C43.947 68.557 39.8 75.225 39.8 82.86a.8.8 0 1 1-1.6 0Zm42.866 0c0-7.635-4.148-14.303-10.317-17.872a.8.8 0 0 1 .8-1.385c6.644 3.843 11.117 11.027 11.117 19.258a.8.8 0 0 1-1.6 0Z"
        fill="#CAE8DF"
      />
      <path
        d="M110 38.464c0 9.3-7.54 16.84-16.84 16.84s-16.84-7.54-16.84-16.84 7.54-16.84 16.84-16.84S110 29.164 110 38.464ZM44.68 38.464c0 9.3-7.54 16.84-16.84 16.84S11 47.764 11 38.464s7.54-16.84 16.84-16.84 16.84 7.54 16.84 16.84Z"
        fill="#E6F4F0"
      />
      <path
        d="M55.127 62.64c1.69-2.916 5.434-3.914 8.363-2.232a6.08 6.08 0 0 1 2.24 8.325l-15.305 26.39c-1.69 2.914-5.435 3.913-8.363 2.23a6.08 6.08 0 0 1-2.24-8.325l15.305-26.389Z"
        fill="#FC0"
      />
      <path
        d="M81.045 89.028 65.739 62.639c-1.69-2.915-5.435-3.914-8.363-2.23a6.08 6.08 0 0 0-2.24 8.324l15.305 26.39c1.69 2.914 5.434 3.913 8.363 2.23a6.08 6.08 0 0 0 2.24-8.325Z"
        fill="#378CC8"
      />
      <path
        d="M61.538 59.691a6.13 6.13 0 0 1 1.952.717 6.08 6.08 0 0 1 2.24 8.325l-5.297 9.134-5.298-9.134a6.08 6.08 0 0 1 2.241-8.325 6.129 6.129 0 0 1 4.162-.717Z"
        fill="#78B441"
      />
      <path
        d="M77.34 48.078c0-.406.343-.735.766-.735h13.778c.423 0 .765.33.765.735v2.327a.612.612 0 0 1-.612.613H77.952a.612.612 0 0 1-.612-.613v-2.327Z"
        fill="#5BBDA0"
      />
      <path
        d="M88.975 48.078c0-.406.34-.735.76-.735h17.464c.42 0 .76.33.76.735v2.327a.612.612 0 0 1-.613.613H89.588a.612.612 0 0 1-.613-.613v-2.327Z"
        fill="#80CCB5"
      />
      <path
        d="M79.79 44.404c0-.406.338-.735.756-.735h11.347c.418 0 .757.33.757.735v2.94H79.79v-2.94Z"
        fill="#5BBDA0"
      />
      <path
        d="M90.2 44.404c0-.406.343-.735.765-.735h13.779c.423 0 .765.33.765.735v2.94H90.2v-2.94Z"
        fill="#80CCB5"
      />
      <path d="M81.168 33.412h9.185v10.717h-9.185V33.412Z" fill="#A6DBCB" />
      <path d="M90.353 33.412h13.778v10.717H90.353V33.412Z" fill="#CAE8DF" />
      <path
        d="M78.565 30.197h17.759v2.94c0 .405-.346.734-.772.734H79.337c-.426 0-.772-.329-.772-.735v-2.939Z"
        fill="#599F40"
      />
      <path
        d="M88.975 30.197h17.147v2.94a.74.74 0 0 1-.746.734H89.721a.74.74 0 0 1-.746-.735v-2.939Z"
        fill="#78B441"
      />
      <path
        d="M92.037 44.282V33.258H95.1v11.023h-3.062ZM96.63 44.282V33.258h3.062v11.023H96.63ZM101.223 33.259v11.023h3.062V33.258h-3.062Z"
        fill="#78B441"
      />
      <path
        d="M92.037 36.32V33.26H95.1v3.062h-3.062ZM96.63 36.32V33.26h3.062v3.062H96.63ZM101.223 33.259v3.062h3.062v-3.062h-3.062Z"
        fill="#599F40"
      />
      <path d="M105.509 32.459a.8.8 0 1 1 0 1.6h-25.72a.8.8 0 1 1 0-1.6h25.72Z" fill="#599F40" />
      <path
        d="M104.897 43.482a.8.8 0 1 1 0 1.6H80.402a.8.8 0 1 1 0-1.6h24.495ZM107.346 47.156a.8.8 0 1 1 0 1.6H77.952a.8.8 0 1 1 0-1.6h29.394Z"
        fill="#5BBDA0"
      />
      <path d="m98.16 22.849-7.96 7.348h15.922l-7.961-7.348Z" fill="#CAE8DF" />
      <path
        d="M87.117 20.399c-.3 0-.586.12-.798.334l-8.648 8.742a1.15 1.15 0 0 0-.245 1.243c.175.426.586.704 1.042.704h10.529c.299 0 .586-.12.797-.334l8.649-8.742a1.15 1.15 0 0 0 .244-1.243 1.128 1.128 0 0 0-1.042-.704H87.117Z"
        fill="#599F40"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.311 20.733a1.247 1.247 0 0 1 1.7 0l9.208 8.742a1.1 1.1 0 0 1 0 1.613 1.246 1.246 0 0 1-1.698 0l-8.36-7.936-8.36 7.936a1.247 1.247 0 0 1-1.699 0 1.1 1.1 0 0 1 0-1.613l9.21-8.742Z"
        fill="#78B441"
      />
      <path
        d="M107.346 30.01a.8.8 0 1 1 0 1.6H78.565a.8.8 0 1 1 0-1.6h28.781ZM20.186 18.562h6.123v9.186h-6.123v-9.186ZM28.146 15.5h6.124l-4.899 1.837v1.225h-6.124v-1.225l4.9-1.837Z"
        fill="#599F40"
      />
      <path d="M35.495 15.5H34.27l-4.899 1.837v1.225h6.124V15.5Z" fill="#78B441" />
      <path d="M17.124 27.748h5.511V49.18h-5.511V27.748Z" fill="#599F40" />
      <path d="M22.635 27.748h7.961V49.18h-7.96V27.748Z" fill="#78B441" />
      <path d="M26.31 18.562h12.247v30.619H26.309V18.562Z" fill="#78B441" />
      <path
        d="M29.796 46.119V28.547h-3.487a.8.8 0 1 1 0-1.6h4.287a.8.8 0 0 1 .8.8V46.12a.8.8 0 0 1-1.6 0Z"
        fill="#007A5F"
      />
      <path
        d="M29.371 21.624h1.837v1.837h-1.837v-1.837ZM33.658 21.624h1.837v1.837h-1.837v-1.837ZM33.658 26.523h1.837v1.837h-1.837v-1.837ZM33.658 30.81h1.837v1.837h-1.837v-1.838ZM33.658 35.096h1.837v1.837h-1.837v-1.837ZM33.658 39.383h1.837v1.837h-1.837v-1.837ZM33.658 43.67h1.837v1.836h-1.837V43.67ZM25.697 30.81h1.837v1.837h-1.837v-1.838ZM25.697 35.096h1.837v1.837h-1.837v-1.837ZM25.697 39.383h1.837v1.837h-1.837v-1.837ZM25.697 43.67h1.837v1.836h-1.837V43.67Z"
        fill="#CAE8DF"
      />
      <path
        d="M36.577 55.876a1.53 1.53 0 0 1 2.165 0l4.33 4.33a1.531 1.531 0 0 1-2.165 2.165l-4.33-4.33a1.53 1.53 0 0 1 0-2.165ZM83.897 55.876a1.53 1.53 0 0 0-2.165 0l-4.33 4.33a1.53 1.53 0 1 0 2.165 2.165l4.33-4.33a1.53 1.53 0 0 0 0-2.165Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgJusbrasilConnections)
